import { matchPath } from 'react-router-dom';
import { hasValue } from '@famly/vet_ts-utils_typescript';
import RouteConfig from './route-config';
/**
 * Returns a flattened array of all paths based on RouteConfig
 */
export const flattenRouteConfig = (routeConfig) => {
    return Object.values(routeConfig).flatMap(route => flattenRoute(route));
};
/**
 * Recursive function to crawl through nested RouteConfigRoutes
 */
const flattenRoute = (route, prepend = '') => {
    if (route.path === '/') {
        return [];
    }
    const path = `${prepend}${route.path}`;
    const pathWithCrew = [path, route.crew];
    if (!hasValue(route.subRoutes)) {
        return [pathWithCrew];
    }
    return [
        pathWithCrew,
        ...Object.values(route.subRoutes).flatMap(route => {
            return flattenRoute(route, path);
        }),
    ];
};
// Compute flattened route config once
const flattenedRouteConfigWithCrews = flattenRouteConfig(RouteConfig);
const flattenedRouteConfig = flattenedRouteConfigWithCrews.map(([path]) => path);
export const findCrewFromPath = (inputPath) => {
    var _a;
    return (_a = flattenedRouteConfigWithCrews.find(([path]) => path === inputPath)) === null || _a === void 0 ? void 0 : _a[1];
};
export const validateStringAsRouteConfigPath = (stringPath, defaultPath = '/login') => (flattenedRouteConfig.includes(stringPath) ? stringPath : defaultPath);
/**
 * @private use findPathFromUrl instead. This is export for test purposes
 */
export const testableFindPathFromUrl = (url, flattenedConfig) => {
    return flattenedConfig.find(path => hasValue(matchPath(url, {
        path,
        exact: true,
        strict: false,
    })));
};
/**
 *
 * @param url following the structure "/account/institution/cool-inst-id/some/route"
 * @param flattenedConfig should not be used, implemented to support stubbing for tests
 * @returns the matching react-router path - e.g. "/account/institution/:institutionId/some/route"
 */
export const findPathFromUrl = (url) => testableFindPathFromUrl(url, flattenedRouteConfig);
/**
 * @deprecated Use `withPath` instead
 */
export const makeBuildSubroutePath = (parentPath) => 
/**
 * @deprecated Use `withPath` instead
 */
(routePath = '') => {
    return `${parentPath}${routePath}`;
};
/**
 * @private use findRouteTemplateFromUncleanUrl instead. This is export for test purposes
 */
export const testableFindRouteTemplateFromUncleanUrl = (findPath) => (uncleanUrl) => {
    const urlWithoutHash = uncleanUrl.split('#')[1];
    const urlWithoutQueryParams = urlWithoutHash === null || urlWithoutHash === void 0 ? void 0 : urlWithoutHash.split('?')[0];
    const routeTemplate = urlWithoutQueryParams ? findPath(urlWithoutQueryParams) : undefined;
    return routeTemplate;
};
/**
 * Converts an "unclean" url to the matching route template.
 *
 * @param uncleanUrl The unclean url. E.g. `#/account/feed/68479d1d-f8c9-4cd3-aa31-ea0c08330315?foo=bar
 *
 * @returns The matching route template. E.g. `/account/feed/:institutionId/
 */
export const findRouteTemplateFromUncleanUrl = testableFindRouteTemplateFromUncleanUrl(findPathFromUrl);
